var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_map"},[_c('van-nav-bar',{attrs:{"title":"车辆轨迹详情","left-text":"返回","left-arrow":""},on:{"click-left":_vm.back}}),_c('div',{attrs:{"id":"container"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }